import RepresentativeAdvancedForm from './RepresentativeAdvancedForm'

export default RepresentativeAdvancedForm
